






































































import Component from 'vue-class-component';
import Vue from 'vue';
import { ticketsDashboard } from '@/modules/shared/shared/store/namespaces';

@Component({})
export default class TicketsLastNMonthsActivity extends Vue {
    totalTicketsInTicketTypes: number = 0;

    @ticketsDashboard.State('tickets') tickets;

    get isLoading() {
        return !this.tickets || !this.tickets.values;
    }

    get customerTicketTypes(): { ticketType: string; total: number }[] {
        const ticketTypes: { ticketType: string; total: number }[] = [];

        if (!this.isLoading && this.tickets.values.ticketsByTicketTypes) {
            let total: number = 0;

            this.tickets.values.ticketsByTicketTypes.forEach(element => {
                total += element.total;

                ticketTypes.push({
                    ticketType: element.ticketType,
                    total: element.total,
                });
            });

            this.totalTicketsInTicketTypes = total;
        }

        return ticketTypes;
    }
}
